import React from "react";
import styled from "styled-components";
import { COLORS } from "containers/impact-report/constants";

const StyledSvg = styled.svg`
  ${({ onClick }) => onClick && "cursor: pointer;"}
`;

const SearchIcon = ({ size = 24, color = COLORS.NEUTRAL_500, ...props }) => (
  <StyledSvg
    width={size}
    height={size}
    viewBox={"0 0 24 24"}
    fill={"none"}
    xmlns={"http://www.w3.org/2000/svg"}
    {...props}
  >
    <path
      d={
        "M8.5 3C5.46243 3 3 5.46243 3 8.5C3 11.5376 5.46243 14 8.5 14C9.83879 14 11.0659 13.5217 12.0196 12.7266L15.6464 16.3536C15.8417 16.5488 16.1583 16.5488 16.3536 16.3536C16.5488 16.1583 16.5488 15.8417 16.3536 15.6464L12.7266 12.0196C13.5217 11.0659 14 9.83879 14 8.5C14 5.46243 11.5376 3 8.5 3ZM4 8.5C4 6.01472 6.01472 4 8.5 4C10.9853 4 13 6.01472 13 8.5C13 10.9853 10.9853 13 8.5 13C6.01472 13 4 10.9853 4 8.5Z"
      }
      fill={color}
    />
  </StyledSvg>
);

export default SearchIcon;
